export default __webpack_public_path__ + "static/media/oneid-large-uk-license.2f854f7d.jpg";